import script from "./TopNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNav.vue?vue&type=script&setup=true&lang=js"

import "./TopNav.vue?vue&type=style&index=0&id=03eeb5fd&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2503735441/src/recipe-ai-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03eeb5fd"]])

export default __exports__